// The player's Spanish-learning choice is saved on the server, and also remembered on this device so the
// tab is there immediately on the next launch (and stays put if the app opens offline or the request fails).
const key = (userId) => `spanishEnabled:${userId || 'me'}`;

export function getCachedSpanishPref(userId) {
  try {
    const v = localStorage.getItem(key(userId));
    return v === null ? null : v === 'true';
  } catch (e) { return null; }
}

export function setCachedSpanishPref(userId, enabled) {
  try { localStorage.setItem(key(userId), enabled ? 'true' : 'false'); } catch (e) { /* not remembered */ }
}
